import type { TChatSummaryDto } from '@homepal/api-contract'

import dayjs from 'utils/dayjs'

export type ChatDay = 'today' | 'yesterday' | 'earlier'

export type ChatGroup = {
  day: ChatDay
  chats: TChatSummaryDto[]
}

export type ChatLabelKey = 'history_row_count' | 'history_yesterday'
  | 'history_other_view'

export type TranslateChat = (
  key: ChatLabelKey,
  values?: Record<string, string>
) => string

export function chatDay(iso: string): ChatDay {
  const date = dayjs(iso)

  if (date.isSame(dayjs(), 'day')) return 'today'

  if (date.isSame(dayjs().subtract(1, 'day'), 'day')) return 'yesterday'

  return 'earlier'
}

const DAY_ORDER: ChatDay[] = ['today', 'yesterday', 'earlier']

// Grouped by the day the chat was started, days in calendar order.
export function groupChatsByDay(chats: TChatSummaryDto[]): ChatGroup[] {
  return DAY_ORDER.map((day) => ({
    day,
    chats: chats.filter((chat) => chatDay(chat.created_at) === day)
  })).filter((group) => group.chats.length > 0)
}

export function chatTime(iso: string): string {
  return dayjs(iso).format('HH:mm')
}

export function chatDate(iso: string): string {
  return dayjs(iso).format('D MMM')
}

// Time for today and yesterday, where the group header carries the day.
export function chatWhen(iso: string): string {
  return chatDay(iso) === 'earlier' ? chatDate(iso) : chatTime(iso)
}

export function rowCountLabel(
  rowCount: number | null,
  t: TranslateChat
): string | null {
  if (rowCount === null) return null

  return t('history_row_count', { count: String(rowCount) })
}
